import fetch from 'utils/fetch';

export function cdrSimList(accountStart,accountEnd,dateStart,dateEnd,agent,zoneId,psize,currentPage) {
    const data = {
        accountStart,
        accountEnd,
        dateStart,
        dateEnd,
        agent,
        zoneId,
        psize,
        currentPage
    };
    return fetch({
        url: '/cdrSimList',
        method: 'get',
        params : data
    });
}

export function dictCountry() {
    return fetch({
        url: '/countryList',
        method: 'get'
    });
}





// WEBPACK FOOTER //
// ./src/api/cdrSimList.js